const DAMAINCONFIG = require('./../../config/index')

export default {
  PLAT_NAME: DAMAINCONFIG.PLAT_NAME,
  APIURL:
    process.env.NODE_ENV === 'development' ? '/api' : DAMAINCONFIG.BASE_API,
  CONFIG: {
    CODE_SUCCESS: 0, // 成功返回状态码
    CODE_USER_CONFLICT: 1006,
    CODE_VERIFY: 1000, //验证通过
  },
  STAFF_STATUS: {
    0: '离职',
    1: '正式员工',
    2: '实习生',
    3: '兼职员工',
  },
  GENDER_STATUS: {
    1: '男',
    2: '女',
  },
  MANAGER_STATUS: {
    0: '失效',
    1: '有效',
  },
  SALARY_TYPE: [
    { key: 1, title: '月薪' },
    { key: 2, title: '日薪' },
  ],
}

export function implantExcel(thead, trContent, fileName = '下载') {
  var type = 'excel'
  var excelFile =
    "<html xmlns:o='urn:schemas-microsoft-com:office:office' xmlns:x='urn:schemas-microsoft-com:office:" +
    type +
    "' xmlns='http://www.w3.org/TR/REC-html40'>"
  excelFile += '<head>'
  excelFile += '<meta http-equiv=Content-Type; content=text/html;charset=UTF-8>'
  excelFile += '<!--[if gte mso 9]>'
  excelFile += '<xml>'
  excelFile += '<x:ExcelWorkbook>'
  excelFile += '<x:ExcelWorksheets>'
  excelFile += '<x:ExcelWorksheet>'
  excelFile += '<x:Name>'
  excelFile += fileName
  excelFile += '</x:Name>'
  excelFile += '<x:WorksheetOptions>'
  excelFile += '<x:DisplayGridlines/>'
  excelFile += '</x:WorksheetOptions>'
  excelFile += '</x:ExcelWorksheet>'
  excelFile += '</x:ExcelWorksheets>'
  excelFile += '</x:ExcelWorkbook>'
  excelFile += '</xml>'
  excelFile += '<![endif]-->'
  excelFile += '</head>'
  excelFile += '<body><table>'
  excelFile += '<tr>'
  for (let i in thead) {
    excelFile += `<td  style="background: #CECECE;text-align:center">${thead[i]}</td>`
  }
  excelFile += '</tr>'
  excelFile += trContent
  excelFile += '</table></body>'
  excelFile += '</html>'
  var base64data =
    'base64,' + window.btoa(unescape(encodeURIComponent(excelFile)))

  // 新建一个a标签,模拟下载,并移除
  let app = document.getElementById('app')
  let downLoadBtn = document.createElement('A')
  downLoadBtn.href = 'data:application/vnd.ms-' + type + ';' + base64data
  downLoadBtn.download = fileName + '.xls'
  downLoadBtn.onclick = function() {
    app.removeChild(this)
  }
  // application/vnd.openxmlformats-officedocument.spreadsheetml.sheet
  app.appendChild(downLoadBtn)
  downLoadBtn.click()
}
